/**
 * YouTube サイドメニュー検索の入力判定（REECH-3657）。
 * チャンネル名モードではチケット指定記号を拒否しない。
 * キーワード側の禁止記号とローマ字1文字拒否は維持する。
 */

/** キーワード／除外キーワードで拒否する記号（チャンネル名モードでは使わない） */
export const REG_YOUTUBE_KEYWORD_FORBIDDEN = /[!"$%'*+,/:;<=>?@[\\\]^`{|}~]/;

/** ローマ字1文字のみ */
export const REG_SINGLE_ALPHA = /^[A-Za-z]$/;

/**
 * チャンネル名として拒否するか（ローマ字1文字のみ）。
 * @param {string} channelName
 * @returns {boolean}
 */
export function isRejectedYoutubeChannelName(channelName) {
  return REG_SINGLE_ALPHA.test(channelName || "");
}

/**
 * キーワード／除外キーワードとして拒否するか。
 * @param {string} value
 * @returns {boolean}
 */
export function isRejectedYoutubeKeywordField(value) {
  const text = value || "";
  return REG_YOUTUBE_KEYWORD_FORBIDDEN.test(text) || REG_SINGLE_ALPHA.test(text);
}

/**
 * ySearch 用の総合判定。true のとき検索せずエラー表示する。
 * @param {{ radio: number, channel_name?: string, keyword?: string, exclude_keyword?: string }} form
 * @returns {boolean}
 */
export function isRejectedYoutubeSearchInput(form) {
  const channelName = form.channel_name || "";
  if (form.radio === 1) {
    return isRejectedYoutubeChannelName(channelName);
  }
  // キーワードモード: 残存 channel_name はローマ字1文字のみ拒否（記号はチャンネル名方針に合わせる）
  return (
    isRejectedYoutubeChannelName(channelName) ||
    isRejectedYoutubeKeywordField(form.keyword) ||
    isRejectedYoutubeKeywordField(form.exclude_keyword)
  );
}

// browser-e2e から同一実装を参照するための公開（REECH-3657）
if (typeof window !== "undefined") {
  window.__REECH_YT_CHANNEL_VALIDATION__ = {
    isRejectedYoutubeSearchInput,
    isRejectedYoutubeChannelName,
    isRejectedYoutubeKeywordField,
  };
}
